import React from 'react';
import { lazyForPaint } from 'react-loosely-lazy';
import PerformanceMark from '@atlassian/jira-common-performance/src/set-performance-mark.tsx';
import { JSErrorBoundary } from '@atlassian/jira-error-boundaries/src/ui/js-error-boundary/index.tsx';
import Placeholder from '@atlassian/jira-placeholder';
import { LOAD_START_MARK_KEY_PROJECT_ACCESS } from '../../common/constants';
import ProjectAccessModalViewWrapperSkeleton from './skeleton';
import type { Props } from './types';
import type ProjectAccessModalViewWrapper from './index';

const LazyComponent = lazyForPaint<typeof ProjectAccessModalViewWrapper>(
	() => import(/* webpackChunkName: "async-project-access-modal-view-wrapper" */ './index'),
);

export const AsyncProjectAccessModalViewWrapperComponent = (props: Props) => (
	<JSErrorBoundary id="async-project-access-modal-view-wrapper" packageName="users-and-roles">
		<Placeholder
			name="project-access-modal-view-wrapper"
			fallback={
				// @ts-expect-error - TS2322 - Type '{ children: Element; metricKey: string; }' is not assignable to type 'IntrinsicAttributes & PerformanceMarkProps'.
				<PerformanceMark metricKey={LOAD_START_MARK_KEY_PROJECT_ACCESS}>
					<ProjectAccessModalViewWrapperSkeleton />
				</PerformanceMark>
			}
		>
			<LazyComponent {...props} />
		</Placeholder>
	</JSErrorBoundary>
);

export default AsyncProjectAccessModalViewWrapperComponent;
